/**
 * @file main.component.spec.ts
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AnnualCapComponent,
  DeductibleComponent,
  ExclusionsComponent,
  PreferredMedicationListComponent,
  CoPayScheduleComponent,
  RequestIdCardComponent,
  AuditLogsComponent,
  ClaimSearchComponent,
  AddMemberComponent,
  MemberSearchComponent,
  AddDependentComponent,
  UpdateMemberComponent,
  UpdateCoverageComponent,
  UpdateContactInfoComponent,
  CapDeductibleMoopComponent,
  PharmacySearchComponent,
  ClaimSearchDetailComponent,
  ClaimSearchCompareComponent,
  DrugPricingComponent,
  PrintIdCardComponent,
  MailOrdersComponent,
  PrescriptionsComponent,
  ClinicalReviewsComponent,
  ExplanationOfBenefitsComponent,
  DashboardComponent,
} from '../management';

import { UserAccessLevel } from '../interfaces/user-access.interface';
import { AccessLevelGuard } from '../core/guards/access-level/access-level.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      { path: 'copay-schedule', component: CoPayScheduleComponent },
      { path: 'annual-cap', component: AnnualCapComponent },
      { path: 'deductible', component: DeductibleComponent },
      { path: 'exclusions', component: ExclusionsComponent },
      {
        path: 'preferred-medication-list',
        component: PreferredMedicationListComponent,
      },
      { path: 'online-eligibility', component: MemberSearchComponent },
      {
        path: 'online-eligibility/add-new-member',
        component: AddMemberComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      { path: 'audit-logs', component: AuditLogsComponent },
      {
        path: 'online-eligibility/add-new-dependent',
        component: AddDependentComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/update-member',
        component: UpdateMemberComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/update-coverage',
        component: UpdateCoverageComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/update-contact-info',
        component: UpdateContactInfoComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/request-id-card',
        component: RequestIdCardComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/claim-search',
        component: ClaimSearchComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/claim-search-detail',
        component: ClaimSearchDetailComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/claim-search-compare',
        component: ClaimSearchCompareComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
            UserAccessLevel.LEVEL_C,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/cap-deductible-moop',
        component: CapDeductibleMoopComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/pharmacy-search',
        component: PharmacySearchComponent,
      },
      {
        path: 'online-eligibility/drug-pricing',
        component: DrugPricingComponent,
      },
      {
        path: 'online-eligibility/print-id-card',
        component: PrintIdCardComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_B,
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/mail-orders',
        component: MailOrdersComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/prescriptions',
        component: PrescriptionsComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/clinical-reviews',
        component: ClinicalReviewsComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
      {
        path: 'online-eligibility/eob',
        component: ExplanationOfBenefitsComponent,
        data: {
          accessLevels: [
            UserAccessLevel.LEVEL_C,
            UserAccessLevel.LEVEL_D,
            UserAccessLevel.LEVEL_E,
          ],
        },
        canActivate: [AccessLevelGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagementRoutingModule {}
